import didCommit from './didCommit_oauth_m2mClient';

export const didCommit_oauth_m2mClient = didCommit;

export default { didCommit_oauth_m2mClient };
